export default {
  categories: [],
  selectedCategories: []
}
